import { useMemo } from "react";
import { styles } from "./VideoPlayer.style";
import { useInView } from "react-intersection-observer";

export interface Video {
  url: string;
  title?: string;
  description?: string;
}

export interface VideoPlayerProps {
  video: Video;
  isAnimation?: boolean;
  isLoop: boolean;
}

export const VideoPlayer = (props: VideoPlayerProps) => {
  const { video, isAnimation, isLoop } = props;
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  const url = useMemo(() => {
    if (inView) {
      return video.url;
    }
    return null;
  }, [inView]);

  const animationSetting = isAnimation && {
    autoPlay: true,
    muted: true,
    loop: isLoop,
    controls: false,
    playsInline: true,
    title: "",
  };
  const videoPlayer = !isAnimation && {
    controls: true,
    preload: "metadata",
  };

  return (
    <div ref={ref} className={styles.wrapper()}>
      <video
        title={video.title}
        disablePictureInPicture={true}
        controlsList="noplaybackrate nodownload"
        controls
        {...animationSetting}
        {...videoPlayer}
      >
        {url && <source src={url} type="video/mp4" />}
      </video>
    </div>
  );
};
